import { useCallback, useMemo } from "react";
import {
  P2Modal,
} from "react-bootstrap-common-script";
import { RepresentByRegistrar } from "../../../utils/shared-radio";
import RadioGroup from "../../../components/form/grouped/radio/radio-group";
import { OutgoingOwnerRepresentedState } from "../application-step-5";
interface DivorceRegistrarRepresentationProps {
  modalOpen: boolean;
  outgoingOwnersRepresented: OutgoingOwnerRepresentedState[];
  setOutgoingOwnersRepresented: (
    value: OutgoingOwnerRepresentedState[]
  ) => void;
  onSubmit: () => void;
  onBack: () => void;
}

function DivorceRegistrarRepresentation({
  modalOpen,
  outgoingOwnersRepresented,
  setOutgoingOwnersRepresented,
  onSubmit,
  onBack,
}: DivorceRegistrarRepresentationProps) {
 const isValid = useMemo(() => {
     const selectedOutgoingOwners = outgoingOwnersRepresented.filter(item => item.is_represented === true);
     return selectedOutgoingOwners.length === 1;
 }, [outgoingOwnersRepresented])
  
 const handleOnBack = useCallback(()=>{
  onBack()
},[onBack])
 
const handleOnSubmit = useCallback(()=>{
  onSubmit()
},[onSubmit])
 
const handleOnSelect = useCallback((item:OutgoingOwnerRepresentedState)=>(e:boolean)=>{
  setOutgoingOwnersRepresented(
    outgoingOwnersRepresented.map((owner) => {
      return {
        ...owner,
        is_represented:
          owner.owner.myinfo.uinfin ===
          item.owner.myinfo.uinfin
            ? e
            : owner?.is_represented,
      };
    })
  );
},[outgoingOwnersRepresented, setOutgoingOwnersRepresented])
 
 return (
    <P2Modal
      className="polymer-registrar-representation__modal"
      isOpen={modalOpen}
      onCloseModal={handleOnBack}
      variant="default"
      title={`Please select which outgoing owners is represented by Registrar`}
      primaryButtonText="Back"
      secondaryButtonText="Proceed"
      primaryButtonFunction={handleOnBack}
      secondaryButtonFunction={handleOnSubmit}
      secondaryButtonDisabled={!isValid}
      children={
        <div className="polymer-registrar-representation">
          <div
            className="polymer-registrar-representation__header"
            style={{ borderBottom: "1px dashed #0C8188", paddingTop: "8px" }}
          >
            <div className="polymer-registrar-representation__column">
              <p>Outgoing Owners</p>
            </div>
            <div className="polymer-registrar-representation__column">
              <p>Represented by Registrar</p>
            </div>
          </div>
          {outgoingOwnersRepresented.map((item, _index) => {
            const key = _index;
            return (
              <div key={key} className="polymer-registrar-representation__row"
                style={{
                  borderBottom:
                    _index !== outgoingOwnersRepresented.length - 1
                      ? "1px dashed #0C8188"
                      : "0px",
                }}
              >
                <div className="polymer-registrar-representation__column">
                  <p>{item.owner.myinfo.name}</p>
                </div>
                <div className="polymer-registrar-representation__column">
                  <RadioGroup
                    layout="default"
                    items={RepresentByRegistrar}
                    onItemSelect={handleOnSelect(item)}
                    value={item?.is_represented}
                    flexDirection="row"
                  />
                </div>
              </div>
            );
          })}
        </div>
      }
    />
  );
}

export default DivorceRegistrarRepresentation;
